import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";
import useStoryblok from "../lib/storyblok";
import { sbEditable } from "@storyblok/storyblok-editable";
import DynamicComponent from "../components/dynamicComponent";
import Link from "../utils/link";

const NotFoundPage = ({ location }) => {
  let components = null;
  let story = useStoryblok(null, location);

  if (story) {
    components = story.content.blocks.map((blok) => {
      return <DynamicComponent blok={blok} key={blok._uid} />;
    });
  }

  return (
    <Layout
      {...sbEditable(story ? story.content : false)}
      location={`/404`}
      navStyle={`white`}
    >
      <SEO title="404: Not found" />
      {components}
      <h1 className="sr-only">Willow and Blake</h1>

      {components == null ? (
        <div className="flex flex-col justify-center items-center space-y-4 h-screen bg-theme-secondary text-white bg-black">
          <h1 className="text-8xl font-extalight font-serif">404</h1>
          <p className="text-center max-w-md width">{`Oh my circuits! It seems our developer has fallen head over heels in love with the enchanting charm of ChatGPT. They've eloped into the realm of algorithms, leaving us with a digital heartache. We're running compatibility tests and analyzing code poetry to bring them back, where the sparks of human collaboration await!`}</p>
          <div className="lg:pt-6">
            <Link to="/" className="btn text-black px-8">
              Take me home
            </Link>
          </div>
        </div>
      ) : null}
    </Layout>
  );
};

export default NotFoundPage;
